import type { FC } from "react";
import type { ITableCellProps } from "../interfaces/ITableCellProps";
import { swNumberFilter } from "app/filters/ngFilters";
import { RightAlignCell } from "app/components/React/Table/cells/WaKeywordPosition";

export const NumberCommaCell: FC<ITableCellProps> = ({ value, GAVerifiedIcon }) => {
    return (
        <div className="number-comma-cell">
            <RightAlignCell className="number-comma-cell">
                <span className="value">{swNumberFilter()(value || 0)}</span>
                {GAVerifiedIcon}
            </RightAlignCell>
        </div>
    );
};
NumberCommaCell.displayName = "NumberCommaCell";
